import { render, staticRenderFns } from "./message-info.vue?vue&type=template&id=3c95863a&"
import script from "./message-info.vue?vue&type=script&lang=js&"
export * from "./message-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports